<div class="row info-container" *ngIf="labelWithIconData">
  <div class="info">
    <app-label-with-icon [data]="labelWithIconData"></app-label-with-icon>
  </div>
</div>
<div class="container">
  <div class="row align-content-between configurator-container-content">
    <div class="col-12">
      <section class="row">
        <app-product-pack *ngFor="let productPack of productPacksPerPages" [productPack]="productPack"
          [countUpEnabled]="countUpEnabled" (counterChanged)="onCounterChanged($event)"
          [ngClass]="{'col-xl-12 col-xga-6': true}">
        </app-product-pack>
      </section>
      <div *ngIf="productPacksPerPages.length === 0" class="container noselect">
        <div class="row justify-content-center">
          <div class="col-12 font-weight-bold">
            <h1>
              {{ 'Unfortunately, there are no tickets available on this day.' | translate }}
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isShowPageNavigationBar || productsGroupDescription" class="col-12">
      <section class="row">
        <div class="col-12" *ngIf="productsGroupDescription">
          <div class="products-group-description">
            <span class="description">{{ productsGroupDescription | translate }}</span>
          </div>
        </div>
        <div class="col-12" *ngIf="isShowPageNavigationBar">
          <div class="d-flex justify-content-between">
            <div>
              <button (click)="onPrevPage()" type="button" [disabled]="isDisablePerPageButton"
                class="btn btn-labeled btn-default page-navigation-button page-navigation-left-button">
                <span class="btn-label large-font-size">
                  <fa-icon [icon]="faCaretLeft"></fa-icon>
                </span>
              </button>
            </div>
            <div class="large-font-size">{{currentPageIndex + 1}} {{'from' | translate}} {{pageCount}}</div>
            <div>
              <button (click)="onNextPage()" type="button" [disabled]="isDisableNextPageButton"
                class="btn btn-labeled btn-default page-navigation-button page-navigation-right-button">
                <span class="btn-label large-font-size">
                  <fa-icon [icon]="faCaretRight"></fa-icon>
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
<!-- <section>
  <app-product-time-spans
    [productTimeSpans]="productTimeSpans"
    [selectedProductTimeSpan]="selectedProductTimeSpan"
    (selectionChanged)="productTimeSpanSelectionChanged($event)"
    class="row justify-content-center"></app-product-time-spans>
</section> -->
